<template>
  <div>
    <h1 class="demo__title">{{ title }}</h1>
    <h4></h4>
    <div v-if="title === 'Description'">
      <br>
      <p class="demo__description" v-if="adformat">{{ getAdDescription }}</p>
      <!--<preview-settings :ad="ad" :inputs="ad.inputs"></preview-settings>-->
    </div>
    <div v-if="title === 'Available Sizes'">
      <br>
      <section v-if="adformat && getSizes">
        <section class="demo__adview" :style="{width: computeWidth(size)}" v-for="size in getSizes">
          <h2 class="demo__adtitle">{{ getDisplaySize(size) }}</h2>
          <ins class='parkave-placement' :style="'position:relative;display:inline-table;width:'+size.width+'px;height:'+size.height+'px;max-width:100%;'"
               :data-parkave-width='size.width'
               :data-parkave-height='size.height'
               :data-parkave-placement='getPlacementUrl'
               :data-parkave-timestamp='getAdTimeStamp'
               :data-parkave-size='size.type'
               :data-parkave-config='config(size)'>
          </ins>
        </section>
      </section>
      <h2 v-if="adformat && !getSizes" class="demo__adtitle">Out of Page</h2>
      <section v-if="adformat && !getSizes" class="window__preview" style="width: 100%; height: 500px;">
        <div class="window__preview__inner">
          <preview-settings :ad="{}" :inputs="{}"></preview-settings>
          <ins class='parkave-placement' style='display:none'
               :data-parkave-placement='getPlacementUrl'
               data-parkave-size='out-of-page'
               :data-parkave-timestamp='getAdTimeStamp'
               data-parkave-config='{}'>
          </ins>
        </div>
      </section>
    </div>
    <div v-if="title === 'Media Kit Material'">
      <div v-if="adformat" id="bs-media-kit-container" class="demo__sub-section" v-html="adformat.media_kit">
      </div>
    </div>
    <div v-if="title === 'Design Information'">
      <div v-if="adformat" id="bs-designer-info-container" class="demo__sub-section" v-html="adformat.designer_info">
      </div>
    </div>
  </div>
</template>

<script>
  import PreviewSettings from '../common/PreviewSettings';

    export default {
      name: 'DemoItem',
      props: ['title', 'adformat'],
      mounted () {
        let s = document.createElement('script');
        s.src = 'https://cdn.getparkave.com/go-sell.js';
        document.body.insertBefore(s, document.body.firstChild);
      },
      methods: {
        getDisplaySize(size) {
          if (size.type == 'fixed') {
            return size.width + 'x' + size.height;
          } else {
            return size.width + ':' + size.height;
          }
        },
        config (size) {
          return JSON.stringify({
            size: {
              width: size.width,
              height: size.height,
              type: size.type
            }
          })
        },
        computeWidth (size) {
          if (size.type === 'fixed') {
            return size.width + 'px'
          } else {
            return 'auto'
          }
        }
      },
      components: {
        previewSettings: PreviewSettings
      },
      computed: {
        getSizes () {
          if (this.adformat) {
            let sizes = [];
            let input = JSON.parse(this.adformat.specification).inputs;

            for (var i = 0; i < input.length; i++) {
              if (input[i].type === 'size') {
                for (var v = 0; v < input[i].options.length; v++) {
                  if (input[i].options[v].type === 'flexible') {
                    sizes.push({
                      width: input[i].options[v].width,
                      type: 'flexible',
                      height: input[i].options[v].height
                    })
                  } else {
                    sizes.push({
                      width: input[i].options[v].width,
                      type: 'fixed',
                      height: input[i].options[v].height
                    })
                  }
                }
                return sizes;
              }
            }
            if (sizes === []) {
              return null;
            }
          }
        },
        getPlacementUrl () {
          if (this.adformat) {
            return this.adformat.preview_placement_id
          }
        },
        getAdDescription () {
          if (this.adformat.description) {
            return this.adformat.description
          } else {
            return JSON.parse(this.adformat.specification).description
          }
        },
        getAdTimeStamp () {
          let d = new Date()
          d.setMinutes(0)
          d.setSeconds(0)
          let ts = d.setMilliseconds(0)
          return ts
        }
      },
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/demo/DemoItem.vue